module.exports = __webpack_public_path__ + "img/tenant_console_name@3x.a8ca928b.png";